import {
  LanderV2MarketingVariant1,
  Variant1EntryLoadingOverlay,
  Variant1AdhocBookingStep,
  Variant1BookingStep,
  Variant1QuoteLoadingOverlay,
  Variant1QuoteDetailStep,
  Variant1QuoteListStep,
} from "../../../Components/LanderV2/annuitycalculator-v1/VariantV1";
import { quoteDetailViewProperties } from "../../../Components/LanderV2/annuitycalculator-v1/quoteGroups";
import { LanderV2CampaignConfig } from "./types";
import { pensionFundQuestion, personalDetailQuestions, sharedSurveyProps } from "./shared";

export const annuitycalculatorV1: LanderV2CampaignConfig = {
  slug: "annuitycalculator-ux2-vlm3",
  heading: "How much will your pension pay out?",
  subheading: "Get the best annuity quotes in as little as 2 minutes.",
  proofLine: "Compare every major UK annuity provider in one secure flow.",
  accent: "magenta",
  surveyFormId: "annuitycalculator-ux2-vlm3",
  funnelTracking: true,
  landingPageTheme: "Pense Variant 1",
  landingPageVariation: "annuitycalculator-ux2-vlm3",
  landingPageVersion: "ux2-vlm3",
  headlineVariants: [
    {
      keywords: ["annuity calculator", "pension calculator", "retirement estimate"],
      heading: "How much will your pension pay out?",
      subheading: "Find out in 2 minutes with our smart annuity calculator.",
    },
    {
      keywords: ["best annuity rates", "compare annuities", "top pension providers"],
      heading: "Compare the UK's best annuity rates for 2026.",
      subheading: "Find the highest-paying providers in less than 2 minutes.",
    },
    {
      keywords: ["annuity quotes", "pension quotes", "get an annuity quote", "free retirement quote"],
      heading: "Ready to see what your pension will pay out?",
      subheading: "Get your personalised quotes in as little as 2 minutes.",
    },
  ],
  initialData: {},
  surveyProps: sharedSurveyProps,
  MarketingComponent: LanderV2MarketingVariant1,
  steps: [
    {
      slug: "quote-entry",
      isEntry: true,
      completeText: "GET QUOTES",
      LoadingComponent: Variant1EntryLoadingOverlay,
      fixedLoadingMs: 2000,
      funnel: { start: "Pension Details Start", complete: ["Pension Details Complete"] },
      schemaPage: {
        name: "quoteEntry",
        elements: [
          pensionFundQuestion,
          {
            type: "ageinput",
            name: "dateOfBirth",
            title: "Your Age Now",
            isRequired: true,
          },
          {
            type: "retirementdate",
            name: "annuity.plannedRetirementDate",
            title: "Date you plan to retire",
            isRequired: true,
          },
        ],
      },
    },
    {
      slug: "personal-details",
      next: "quotes",
      completeText: "SEE QUOTES",
      fetchesQuotes: true,
      LoadingComponent: Variant1QuoteLoadingOverlay,
      funnel: {
        start: "Personal Details Start",
        complete: ["Personal Details Complete", "Lead With Email", "Lead With Phone", "Lead With Address"],
      },
      schemaPage: {
        name: "personalDetails",
        title: "Good news! We have some great quotes waiting!",
        description: "To check eligibility and store your quotes securely, we just need a little information",
        elements: personalDetailQuestions,
      },
      layoutClassName: "pa-v1-personal-survey",
      illustrationSrc: "/media/illustrations/BW/PNG/like.png",
      illustrationAlt: "",
    },
    {
      slug: "quotes",
      Component: Variant1QuoteListStep,
      previous: "personal-details",
      completeText: "Finish",
      startOverOnNav: true,
      funnel: {
        view: "Quotes Viewed",
        viewProperties: ({ quotes }) => ({ quote_count: String(quotes.length) }),
      },
      schemaPage: {
        name: "quotes",
        title: "Your quotes are ready",
        elements: [],
      },
    },
    {
      slug: "quote-detail",
      Component: Variant1QuoteDetailStep,
      previous: "quotes",
      completeText: "Next",
      startOverOnNav: false,
      funnel: { view: "Quote Detail Viewed", viewProperties: quoteDetailViewProperties },
      schemaPage: {
        name: "quoteDetail",
        title: "Your Quote",
        elements: [],
      },
    },
    {
      slug: "booking",
      Component: Variant1BookingStep,
      previous: "quote-detail",
      completeText: "Book",
      startOverOnNav: false,
      funnel: {
        view: "Booking Page Viewed",
        // The quotes step shows a "no quotes" panel with its own booking button.
        viewProperties: ({ quotes, from }): Record<string, string> =>
          from === "quotes" && quotes.length === 0 ? { from: "no-quotes" } : {},
      },
      schemaPage: {
        name: "booking",
        title: "Book an appointment",
        elements: [],
      },
    },
    {
      slug: "book-appointment",
      Component: Variant1AdhocBookingStep,
      offFunnel: true,
      completeText: "Book",
      startOverOnNav: false,
      schemaPage: {
        name: "adhocBooking",
        title: "Book an appointment",
        elements: [],
      },
    },
  ],
};
